import { render, staticRenderFns } from "./file-upload-fileTypes-editor.vue?vue&type=template&id=fc364fa2&scoped=true&"
import script from "./file-upload-fileTypes-editor.vue?vue&type=script&lang=js&"
export * from "./file-upload-fileTypes-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc364fa2",
  null
  
)

export default component.exports